var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isAbroad ? _c("AuthorCard") : _vm._e(),
      _vm._v(" "),
      _vm.articleGrade < 2
        ? [
            _vm.showSearch ? _c("Search") : _vm._e(),
            _vm._v(" "),
            _vm.isGradeA
              ? [
                  _c("div", {
                    staticClass: "godA",
                    attrs: { id: "nav_button", "data-spm": "ad-right-sponsor" },
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "godR",
                    style: _vm.getGod1Style,
                    attrs: { id: "god_1", "data-spm": "ad-sq1" },
                  }),
                  _vm._v(" "),
                  _c("div", {
                    style: _vm.getGod1_2Style,
                    attrs: { id: "god_1_2", "data-spm": "ad-sq1" },
                  }),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.showHotGallery ? _c("HotGallery") : _vm._e(),
            _vm._v(" "),
            _vm.isGradeA
              ? [
                  _vm.isAbroad
                    ? _c("div", {
                        staticStyle: { width: "300px", margin: "0 auto" },
                        attrs: {
                          id: "jingxuan-taboola",
                          "data-spm": "jingxuan-taboola",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "godR",
                    staticStyle: { display: "block" },
                    attrs: { id: "god_2", "data-spm": "ad-sq2" },
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticStyle: { padding: "10px 20px", display: "none" },
                    attrs: { id: "god_2_2", "data-spm": "ad-sq2" },
                  }),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { class: [_vm.needSticky && "right-fixed"] },
              [
                _c("Hot24News"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isGradeA && _vm.needSticky,
                        expression: "isGradeA && needSticky",
                      },
                    ],
                  },
                  [
                    _c("div", {
                      staticClass: "godR",
                      staticStyle: { display: "block" },
                      attrs: { id: "god_fix_1", "data-spm": "ad-sq6" },
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "god-ad-fix",
                      staticStyle: { display: "none", overflow: "hidden" },
                      attrs: { id: "god_6_2", "data-spm": "ad-sq6" },
                    }),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.isGradeA
              ? [
                  _c("div", {
                    staticClass: "godR",
                    staticStyle: { display: "block" },
                    attrs: { id: "god_3", "data-spm": "ad-sq3" },
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticStyle: { padding: "10px 20px", display: "none" },
                    attrs: { id: "god_3_2", "data-spm": "ad-sq3" },
                  }),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("RecommendWriter"),
            _vm._v(" "),
            _vm.isGradeA
              ? [
                  _c("div", {
                    staticClass: "godR",
                    staticStyle: { display: "block" },
                    attrs: { id: "god_4", "data-spm": "ad-sq4" },
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticStyle: { padding: "10px 20px", display: "none" },
                    attrs: { id: "god_4_2", "data-spm": "ad-sq4" },
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticStyle: { padding: "10px 20px" },
                    attrs: { id: "god_5", "data-spm": "sqfive-ad" },
                  }),
                ]
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }